import { createStore, applyMiddleware, compose } from 'redux';
import createDebounce from 'redux-debounced';
import createSageMiddleware from 'redux-saga';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import thunk from 'redux-thunk';
import rootReducer from '../reducers/rootReducer';
import rootSaga from '../sagas';

const sagaMiddleware = createSageMiddleware();

const persistConfig = {
  key: 'root',
  storage,
  blacklist: [
    'auth',
    'profile',
    'options',
    'fetcher',
    'responseLoading',
    'benchmark',
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const middlewares = [sagaMiddleware, thunk, createDebounce()];

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const configureStore = (initialState) => {
  const store = createStore(
    persistedReducer,
    initialState,
    composeEnhancers(applyMiddleware(...middlewares))
  );
  sagaMiddleware.run(rootSaga);
  const persistor = persistStore(store);
  return { store, persistor };
};

const { store, persistor } = configureStore({});

export { store, persistor };

export const dispatch = (action) => store.dispatch(action);
